import ChatPanel from '../components/ChatPanel';
import { useIsMobile } from '../hooks/useIsMobile';

const HomePage = () => {  
  const isMobile = useIsMobile();
  
  return (
    <div className="relative flex h-full min-h-0 flex-col items-center overflow-hidden px-4 pb-4 pt-16 sm:px-6 sm:py-6 md:px-10 md:py-10">
      {!isMobile && (
        <div className="flex w-full flex-col items-center">
          <div className="flex flex-row items-center">
            <img
              src="/dexter.png"
              alt="Dexter logo"
              className="h-20 w-20 rounded-lg object-cover"
            />
            <h1 className="text-4xl font-semibold tracking-tight text-slate-50">
              Dexter
            </h1>
          </div>

          <div className="mt-0">
            <span className="text-med text-slate-400">
              Your relationship assistant
            </span>
          </div>
        </div>
      )}

      <div className="flex w-full max-w-6xl min-h-0 flex-1">
        <ChatPanel />
      </div>
    </div>
  );
};

export default HomePage;
